import SSRIcon, {
  type SSRIconAttributes,
  type SSRIconProps,
} from "@ingka/ssr-icon";
import aiGeneratedIcon from "@ingka/ssr-icon/paths/ai-generated";
import archiveBoxIcon from "@ingka/ssr-icon/paths/archive-box";
import arrowCounterclockwiseIcon from "@ingka/ssr-icon/paths/arrow-counterclockwise";
import arrowDownIcon from "@ingka/ssr-icon/paths/arrow-down";
import arrowDownToLineIcon from "@ingka/ssr-icon/paths/arrow-down-to-line";
import arrowLeftIcon from "@ingka/ssr-icon/paths/arrow-left";
import arrowLeftArrowRightIcon from "@ingka/ssr-icon/paths/arrow-left-arrow-right";
import arrowRightIcon from "@ingka/ssr-icon/paths/arrow-right";
import arrowRightFromBaseIcon from "@ingka/ssr-icon/paths/arrow-right-from-base";
import arrowUpIcon from "@ingka/ssr-icon/paths/arrow-up";
import arrowUpArrowDownIcon from "@ingka/ssr-icon/paths/arrow-up-arrow-down";
import bellIcon from "@ingka/ssr-icon/paths/bell";
import boxIcon from "@ingka/ssr-icon/paths/box";
import briefcaseIcon from "@ingka/ssr-icon/paths/briefcase";
import calendarIcon from "@ingka/ssr-icon/paths/calendar";
import calendarCancelIcon from "@ingka/ssr-icon/paths/calendar-cancel";
import calendarRescheduleIcon from "@ingka/ssr-icon/paths/calendar-reschedule";
import chatIcon from "@ingka/ssr-icon/paths/chat";
import checkmarkIcon from "@ingka/ssr-icon/paths/checkmark";
import checkmarkBoxIcon from "@ingka/ssr-icon/paths/checkmark-box";
import checkmarkCircleIcon from "@ingka/ssr-icon/paths/checkmark-circle";
import checkmarkSmallIcon from "@ingka/ssr-icon/paths/checkmark-small";
import chevronDownIcon from "@ingka/ssr-icon/paths/chevron-down";
import chevronDownSmallIcon from "@ingka/ssr-icon/paths/chevron-down-small";
import chevronLeftIcon from "@ingka/ssr-icon/paths/chevron-left";
import chevronRightIcon from "@ingka/ssr-icon/paths/chevron-right";
import chevronRightSmallIcon from "@ingka/ssr-icon/paths/chevron-right-small";
import chevronUpIcon from "@ingka/ssr-icon/paths/chevron-up";
import chevronUpSmallIcon from "@ingka/ssr-icon/paths/chevron-up-small";
import circleIcon from "@ingka/ssr-icon/paths/circle";
import clipboardCheckmarkIcon from "@ingka/ssr-icon/paths/clipboard-checkmark";
import clipboardPencilIcon from "@ingka/ssr-icon/paths/clipboard-pencil";
import clockIcon from "@ingka/ssr-icon/paths/clock";
import coworkerIcon from "@ingka/ssr-icon/paths/co-worker";
import copyIcon from "@ingka/ssr-icon/paths/copy";
import createNewIcon from "@ingka/ssr-icon/paths/create-new";
import creditCardIcon from "@ingka/ssr-icon/paths/credit-card";
import crossIcon from "@ingka/ssr-icon/paths/cross";
import crossBoxIcon from "@ingka/ssr-icon/paths/cross-box";
import crossCircleIcon from "@ingka/ssr-icon/paths/cross-circle";
import crossSmallIcon from "@ingka/ssr-icon/paths/cross-small";
import defineSpaceIcon from "@ingka/ssr-icon/paths/define-space";
import documentIcon from "@ingka/ssr-icon/paths/document";
import documentAddIcon from "@ingka/ssr-icon/paths/document-add";
import documentAlertIcon from "@ingka/ssr-icon/paths/document-alert";
import documentCheckmarkIcon from "@ingka/ssr-icon/paths/document-checkmark";
import documentFinancialIcon from "@ingka/ssr-icon/paths/document-financial";
import documentMagnifyingIcon from "@ingka/ssr-icon/paths/document-magnifying-glass";
import documentPencilIcon from "@ingka/ssr-icon/paths/document-pencil";
import documentUploadIcon from "@ingka/ssr-icon/paths/document-upload";
import drillIcon from "@ingka/ssr-icon/paths/drill";
import ellipsesHorizontalIcon from "@ingka/ssr-icon/paths/ellipses-horizontal";
import ellipsesVerticalIcon from "@ingka/ssr-icon/paths/ellipses-vertical";
import feedbackHappyIcon from "@ingka/ssr-icon/paths/feedback-happy";
import filtersIcon from "@ingka/ssr-icon/paths/filters";
import folderIcon from "@ingka/ssr-icon/paths/folder";
import gearIcon from "@ingka/ssr-icon/paths/gear";
import handWithHeartIcon from "@ingka/ssr-icon/paths/hand-with-heart";
import headphonesIcon from "@ingka/ssr-icon/paths/headphones";
import historyIcon from "@ingka/ssr-icon/paths/history";
import homeIcon from "@ingka/ssr-icon/paths/home";
import hotDrinkIcon from "@ingka/ssr-icon/paths/hot-drink";
import imageIcon from "@ingka/ssr-icon/paths/image";
import imageStrikethroughIcon from "@ingka/ssr-icon/paths/image-strikethrough";
import informationIcon from "@ingka/ssr-icon/paths/information";
import informationCircleIcon from "@ingka/ssr-icon/paths/information-circle";
import laptopPencilIcon from "@ingka/ssr-icon/paths/laptop-pencil";
import linkOutIcon from "@ingka/ssr-icon/paths/link-out";
import linkStrikethrough from "@ingka/ssr-icon/paths/link-strikethrough";
import listIcon from "@ingka/ssr-icon/paths/list";
import locationPinIcon from "@ingka/ssr-icon/paths/location-pin";
import locationPinSmallIcon from "@ingka/ssr-icon/paths/location-pin-small";
import lockIcon from "@ingka/ssr-icon/paths/lock";
import magnifyingGlassIcon from "@ingka/ssr-icon/paths/magnifying-glass";
import magnifyingGlassListIcon from "@ingka/ssr-icon/paths/magnifying-glass-list";
import mailIcon from "@ingka/ssr-icon/paths/mail";
import mapIcon from "@ingka/ssr-icon/paths/map";
import missingIcon from "@ingka/ssr-icon/paths/missing";
import mobileHandoverIcon from "@ingka/ssr-icon/paths/mobile-handover";
import moneyCashIcon from "@ingka/ssr-icon/paths/money-cash";
import noteIcon from "@ingka/ssr-icon/paths/note";
import ovalIcon from "@ingka/ssr-icon/paths/oval";
import panIcon from "@ingka/ssr-icon/paths/pan";
import pencilIcon from "@ingka/ssr-icon/paths/pencil";
import peopleIcon from "@ingka/ssr-icon/paths/people";
import personIcon from "@ingka/ssr-icon/paths/person";
import personWithShoppingBagIcon from "@ingka/ssr-icon/paths/person-with-shopping-bag";
import phoneIcon from "@ingka/ssr-icon/paths/phone";
import pinIcon from "@ingka/ssr-icon/paths/pin";
import pinFilledIcon from "@ingka/ssr-icon/paths/pin-filled";
import playIcon from "@ingka/ssr-icon/paths/play";
import plusIcon from "@ingka/ssr-icon/paths/plus";
import questionMarkCircleIcon from "@ingka/ssr-icon/paths/question-mark-circle";
import rectangleVerticalIcon from "@ingka/ssr-icon/paths/rectangle-vertical";
import rectangleVerticalDoubleIcon from "@ingka/ssr-icon/paths/rectangle-vertical-double";
import shapeCornerIcon from "@ingka/ssr-icon/paths/shape-corner";
import shapeFreeIcon from "@ingka/ssr-icon/paths/shape-free";
import shapeLIcon from "@ingka/ssr-icon/paths/shape-l";
import shapeOrganicIcon from "@ingka/ssr-icon/paths/shape-organic";
import shapeUIcon from "@ingka/ssr-icon/paths/shape-u";
import shoppingBagIcon from "@ingka/ssr-icon/paths/shopping-bag";
import shoppingBagAddIcon from "@ingka/ssr-icon/paths/shopping-bag-add";
import sparklesIcon from "@ingka/ssr-icon/paths/sparkles";
import speechBubbleIcon from "@ingka/ssr-icon/paths/speech-bubble";
import starIcon from "@ingka/ssr-icon/paths/star";
import startFilledIcon from "@ingka/ssr-icon/paths/star-filled";
import starhalfFilledIcon from "@ingka/ssr-icon/paths/star-half-filled";
import stopIcon from "@ingka/ssr-icon/paths/stop";
import storeIcon from "@ingka/ssr-icon/paths/store";
import tagIcon from "@ingka/ssr-icon/paths/tag";
import thumbsDownIcon from "@ingka/ssr-icon/paths/thumbs-down";
import thumbsDownFilledIcon from "@ingka/ssr-icon/paths/thumbs-down-filled";
import thumbsUpIcon from "@ingka/ssr-icon/paths/thumbs-up";
import thumbsUpFilledIcon from "@ingka/ssr-icon/paths/thumbs-up-filled";
import trashCanIcon from "@ingka/ssr-icon/paths/trash-can";
import visibilityHideIcon from "@ingka/ssr-icon/paths/visibility-hide";
import visibilityShowIcon from "@ingka/ssr-icon/paths/visibility-show";
import warehouseIcon from "@ingka/ssr-icon/paths/warehouse";
import warningTriangleIcon from "@ingka/ssr-icon/paths/warning-triangle";
import zoomInIcon from "@ingka/ssr-icon/paths/zoom-in";
import zoomOutIcon from "@ingka/ssr-icon/paths/zoom-out";

const IconMap = {
  "archive-box": archiveBoxIcon,
  "arrow-counter-clockwise": arrowCounterclockwiseIcon,
  "arrow-down-to-line": arrowDownToLineIcon,
  "arrow-down": arrowDownIcon,
  "arrow-left-arrow-right": arrowLeftArrowRightIcon,
  "arrow-left": arrowLeftIcon,
  "arrow-right-from-base": arrowRightFromBaseIcon,
  "arrow-right": arrowRightIcon,
  "arrow-up-arrow-down": arrowUpArrowDownIcon,
  "arrow-up": arrowUpIcon,
  "calendar-cancel": calendarCancelIcon,
  "calendar-reschedule": calendarRescheduleIcon,
  "checkmark-box": checkmarkBoxIcon,
  "checkmark-circle": checkmarkCircleIcon,
  "checkmark-small": checkmarkSmallIcon,
  "chevron-down-small": chevronDownSmallIcon,
  "chevron-down": chevronDownIcon,
  "chevron-left": chevronLeftIcon,
  "chevron-right-small": chevronRightSmallIcon,
  "chevron-right": chevronRightIcon,
  "chevron-up-small": chevronUpSmallIcon,
  "chevron-up": chevronUpIcon,
  "clipboard-checkmark": clipboardCheckmarkIcon,
  "clipboard-pencil": clipboardPencilIcon,
  "credit-card": creditCardIcon,
  "cross-box": crossBoxIcon,
  "cross-circle": crossCircleIcon,
  "cross-small": crossSmallIcon,
  "define-space": defineSpaceIcon,
  "document-add": documentAddIcon,
  "document-alert": documentAlertIcon,
  "document-checkmark": documentCheckmarkIcon,
  "document-financial": documentFinancialIcon,
  "document-magnifying-glass": documentMagnifyingIcon,
  "document-pencil": documentPencilIcon,
  "document-upload": documentUploadIcon,
  "ellipses-horizontal": ellipsesHorizontalIcon,
  "ellipses-vertical": ellipsesVerticalIcon,
  "feedback-happy": feedbackHappyIcon,
  "hand-with-heart": handWithHeartIcon,
  "hot-drink": hotDrinkIcon,
  image: imageIcon,
  "image-strikethrough": imageStrikethroughIcon,
  "information-circle": informationCircleIcon,
  "laptop-pencil": laptopPencilIcon,
  "link-out": linkOutIcon,
  "link-strikethrough": linkStrikethrough,
  "location-pin-small": locationPinSmallIcon,
  "location-pin": locationPinIcon,
  "magnifying-glass-list": magnifyingGlassListIcon,
  "magnifying-glass": magnifyingGlassIcon,
  "mobile-handover": mobileHandoverIcon,
  "money-cash": moneyCashIcon,
  "pin-filled": pinFilledIcon,
  "person-with-shopping-bag": personWithShoppingBagIcon,
  "question-mark-circle": questionMarkCircleIcon,
  "rectangle-vertical-double": rectangleVerticalDoubleIcon,
  "rectangle-vertical": rectangleVerticalIcon,
  "shape-corner": shapeCornerIcon,
  "shape-free": shapeFreeIcon,
  "shape-l": shapeLIcon,
  "shape-organic": shapeOrganicIcon,
  "shape-u": shapeUIcon,
  "shopping-bag-add": shoppingBagAddIcon,
  "shopping-bag": shoppingBagIcon,
  sparkles: sparklesIcon,
  "speech-bubble": speechBubbleIcon,
  "star-filled": startFilledIcon,
  "star-half-filled": starhalfFilledIcon,
  "trash-can": trashCanIcon,
  "visibility-show": visibilityShowIcon,
  "visibility-hide": visibilityHideIcon,
  "warning-triangle": warningTriangleIcon,
  "zoom-in": zoomInIcon,
  "zoom-out": zoomOutIcon,
  bell: bellIcon,
  box: boxIcon,
  briefcase: briefcaseIcon,
  calendar: calendarIcon,
  chat: chatIcon,
  checkmark: checkmarkIcon,
  circle: circleIcon,
  clock: clockIcon,
  copy: copyIcon,
  cross: crossIcon,
  document: documentIcon,
  drill: drillIcon,
  filters: filtersIcon,
  folder: folderIcon,
  gear: gearIcon,
  headphones: headphonesIcon,
  home: homeIcon,
  information: informationIcon,
  list: listIcon,
  lock: lockIcon,
  mail: mailIcon,
  map: mapIcon,
  missing: missingIcon,
  note: noteIcon,
  oval: ovalIcon,
  pan: panIcon,
  pencil: pencilIcon,
  people: peopleIcon,
  person: personIcon,
  phone: phoneIcon,
  pin: pinIcon,
  play: playIcon,
  plus: plusIcon,
  star: starIcon,
  stop: stopIcon,
  store: storeIcon,
  tag: tagIcon,
  warehouse: warehouseIcon,
  "co-worker": coworkerIcon,
  "create-new": createNewIcon,
  "thumbs-up-filled": thumbsUpFilledIcon,
  "thumbs-down-filled": thumbsDownFilledIcon,
  "thumbs-up": thumbsUpIcon,
  "thumbs-down": thumbsDownIcon,
  history: historyIcon,
  aiGenerated: aiGeneratedIcon,
};

export type IconName = keyof typeof IconMap;
export type IconType = (typeof IconMap)[IconName];

const getIconByName = (iconName?: IconName): IconType | undefined => {
  if (!iconName) {
    return undefined;
  }
  return iconName in IconMap ? IconMap[iconName] : undefined;
};

const Icon = (props: SSRIconProps & SSRIconAttributes) => {
  return <SSRIcon prefix="saleslead__" {...props} />;
};

export {
  archiveBoxIcon,
  arrowCounterclockwiseIcon,
  arrowDownIcon,
  arrowDownToLineIcon,
  arrowLeftArrowRightIcon,
  arrowLeftIcon,
  arrowRightFromBaseIcon,
  arrowRightIcon,
  arrowUpArrowDownIcon,
  arrowUpIcon,
  bellIcon,
  boxIcon,
  briefcaseIcon,
  calendarCancelIcon,
  calendarIcon,
  calendarRescheduleIcon,
  chatIcon,
  checkmarkBoxIcon,
  checkmarkCircleIcon,
  checkmarkIcon,
  checkmarkSmallIcon,
  chevronDownIcon,
  chevronDownSmallIcon,
  chevronLeftIcon,
  chevronRightIcon,
  chevronRightSmallIcon,
  chevronUpIcon,
  chevronUpSmallIcon,
  circleIcon,
  clipboardCheckmarkIcon,
  clipboardPencilIcon,
  clockIcon,
  copyIcon,
  creditCardIcon,
  crossBoxIcon,
  crossCircleIcon,
  crossIcon,
  crossSmallIcon,
  defineSpaceIcon,
  documentAddIcon,
  documentAlertIcon,
  documentCheckmarkIcon,
  documentFinancialIcon,
  documentIcon,
  documentMagnifyingIcon,
  documentPencilIcon,
  documentUploadIcon,
  drillIcon,
  ellipsesHorizontalIcon,
  ellipsesVerticalIcon,
  feedbackHappyIcon,
  filtersIcon,
  folderIcon,
  gearIcon,
  getIconByName,
  handWithHeartIcon,
  headphonesIcon,
  historyIcon,
  homeIcon,
  hotDrinkIcon,
  Icon,
  imageIcon,
  imageStrikethroughIcon,
  informationCircleIcon,
  informationIcon,
  laptopPencilIcon,
  linkOutIcon,
  linkStrikethrough,
  listIcon,
  locationPinIcon,
  locationPinSmallIcon,
  lockIcon,
  magnifyingGlassIcon,
  magnifyingGlassListIcon,
  mailIcon,
  mapIcon,
  missingIcon,
  mobileHandoverIcon,
  moneyCashIcon,
  noteIcon,
  ovalIcon,
  panIcon,
  pencilIcon,
  peopleIcon,
  personIcon,
  personWithShoppingBagIcon,
  phoneIcon,
  pinFilledIcon,
  pinIcon,
  playIcon,
  plusIcon,
  questionMarkCircleIcon,
  rectangleVerticalDoubleIcon,
  rectangleVerticalIcon,
  shapeCornerIcon,
  shapeFreeIcon,
  shapeLIcon,
  shapeOrganicIcon,
  shapeUIcon,
  shoppingBagAddIcon,
  shoppingBagIcon,
  sparklesIcon,
  speechBubbleIcon,
  starhalfFilledIcon,
  starIcon,
  startFilledIcon,
  stopIcon,
  storeIcon,
  tagIcon,
  trashCanIcon,
  visibilityShowIcon,
  visibilityHideIcon,
  warehouseIcon,
  warningTriangleIcon,
  zoomInIcon,
  zoomOutIcon,
  coworkerIcon,
  createNewIcon,
  thumbsUpIcon,
  thumbsDownIcon,
  thumbsUpFilledIcon,
  thumbsDownFilledIcon,
  aiGeneratedIcon,
};
